<template>
  <v-content>
    <AppBar title="Bemanning" />
    <v-container class="pb-8">
      <v-row no-gutters>
        <v-col>
          <v-dialog
            ref="dialog"
            v-model="dateModal"
            :return-value.sync="model.date"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                filled
                v-model="model.date"
                label="Datum"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="sv"
              first-day-of-week="1"
              v-model="model.date"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateModal = false"
                >Avbryt</v-btn
              >
              <v-btn text color="primary" @click="$refs.dialog.save(model.date)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>

          <v-text-field
            filled
            label="Tågnummer"
            type="number"
            v-model.number="model.train_number"
          />

          <v-select
            v-model="model.cause"
            :items="causes"
            filled
            label="Orsak till förstärkningsbehov"
          />

          <v-select
            v-model="model.solution"
            :items="solutions"
            filled
            label="Typ av förstärkningsbehov"
          />
          <v-textarea filled label="Övrigt" v-model="model.comment" />
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="showValidationModal" max-width="290">
      <ValidationModal
        :errors="validationErrors"
        @close="showValidationModal = false"
        v-if="showValidationModal"
      />
    </v-dialog>
    <v-footer fixed color="white" elevation="2" class="pa-2">
      <v-spacer></v-spacer>
      <v-btn
        :disabled="
          !model.train_number || model.train_number.toString().length < 4
        "
        :loading="pendingRegister"
        tile
        color="primary"
        @click="onRegister"
        >Registrera</v-btn
      >
    </v-footer>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar.vue'
import ValidationModal from '@/components/ValidationModal'
import { format } from 'date-fns'
import gql from 'graphql-tag'

const causes = [
  'Ovilja att betala',
  'Många resenärer',
  'AGS/säkerhetsprioritering',
  'Annat (skriv kommentar!)'
]

const solutions = ['Ombordmedarbetare', 'Biljettkontrollant']

export default {
  name: 'StaffDeviation',

  components: {
    AppBar,
    ValidationModal
  },

  data: () => ({
    causes,
    solutions,
    showValidationModal: false,
    pendingRegister: false,
    dateModal: false,
    model: {
      train_number: null,
      date: format(new Date(), 'yyyy-MM-dd'),
      cause: null,
      solution: null,
      comment: null
    }
  }),

  methods: {
    async onRegister() {
      if (this.validationErrors.length) {
        return (this.showValidationModal = true)
      }

      this.pendingRegister = true
      if (!this.model.comment) {
        this.model.comment = ''
      }

      const { data } = await this.$apollo.mutate({
        mutation: gql`
          mutation registerStaffDeviation(
            $payload: RegisterStaffDeviationInput!
          ) {
            registerStaffDeviation(payload: $payload) {
              train_number
              user
              date
              cause
              solution
              created
            }
          }
        `,

        variables: {
          payload: {
            ...this.model
          }
        }
      })
      this.$store.set('registration/data', data.registerStaffDeviation)
      this.$router.push('/staff-deviation-registration-completed')
      this.pendingRegister = false
    }
  },

  computed: {
    validationErrors() {
      const errors = []

      if (!this.model.cause) {
        errors.push('Orsak till förstärkningsbehov ej vald')
      }

      if (!this.model.solution) {
        errors.push('Typ av förstärkningsbehov ej vald')
      }

      return errors
    }
  }
}
</script>
